import { useTrackCTA } from '../../../utils/Tracking/CtaClick/TrackCtaClick';

export const createHandleLoginClick =
  (trackCTA: ReturnType<typeof useTrackCTA>, redirectToLoginPage: (returnTo?: string) => void) => () => {
    trackCTA({
      cta_position: 'content',
      text: 'Logg inn for å få kampanjekode',
    });

    redirectToLoginPage(`${window.location.origin}${window.location.pathname}`);
  };
